import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import TranslationContainer from '../inputs/TranslationInputContainer';
import AnswersInputContainer from '../inputs/AnswersInputContainer';
import SlicesInputContainer from '../inputs/SlicesInputContainer';
import Audios from '../inputs/Audios';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import TextInput from '../../../../core/form/TextInput';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const GapFillLetterItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    {!props.isTestItem && (
      <TranslationContainer
        onChange={props.onChange}
        submitting={props.submitting}
        values={props.values}
        errors={props.errors}
        disabled={props.disabled}
      />
    )}
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Image Prompt"
          fieldType="textarea"
          textAreaRows="4"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'imagePrompt', '')}
          onChange={(value) => props.onChange('imagePrompt', value)}
          errorText={get(props.errors, 'imagePrompt', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={4}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          submitting={props.submitting}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      <Column size={4}>
        <LocalFileInput
          label="Upload an image to the item"
          accept="image"
          cropSize={{ width: 960, height: 640 }}
          disabled={props.disabled}
          value={get(props.values, 'image', '')}
          onChange={(key) => props.onChange('image', key)}
          errorText={get(props.errors, 'image', '')}
        />
      </Column>
    </Row>
    <SlicesInputContainer
      onSplit={(value) => [...value]}
      onChange={(answers) => {
        props.onChange('answers', answers);
        props.onChange(
          'indexesToRemove',
          answers.filter((slice) => slice.index !== undefined)
        ); // this is to show errors
      }}
      text={get(props.values, 'text', '')}
      value={get(props.values, 'answers', [])}
      errorText={get(props.errors, 'indexesToRemove', '')}
      disabled={props.disabled}
      maxRemovesAllowed={1}
    />
    <AnswersInputContainer
      answerType="WRONG"
      value={get(props.values, 'answers', [])}
      onChange={(answers) => props.onChange('answers', answers)}
      errorText={get(props.errors, 'answers', '')}
      disabled={props.disabled}
    />
  </div>
);

GapFillLetterItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  isTestItem: PropTypes.bool,
};

GapFillLetterItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  onChange: () => false,
  disabled: false,
  isTestItem: false,
};

export default GapFillLetterItemForm;
